import { ConnectorsPanel } from "./ConnectorsPanel";

export function Connectors() {
  return <ConnectorsPanel />;
}
